import React from 'react';

export const Spinner: React.FunctionComponent<{minHeight?: number, isSmall?:boolean}> = ({minHeight = 200, isSmall=false}) => {
  return <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: `${minHeight}px` }}>
    <div className={`spinner-border ${isSmall && "spinner-border-sm"}`} role="status"></div>
  </div>

}